import axios from 'axios'
import qs from 'qs'
import iView from 'view-design'
import JSEncrypt from 'jsencrypt'
import SparkMD5 from 'spark-md5'

axios.defaults.timeout = 5000000 // 响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = ''

var root = process.env.VUE_APP_API_URL
// 请求拦截
axios.interceptors.request.use((config) => {
  config.withCredentials = true
  // this.$cookieStore.getCookie(config)
  if (config.url.indexOf('zw-user') != -1 || config.url.indexOf('zw-public') != -1) {
    config.url = config.url
  } else {
    config.url = root + config.url
  }
  let pubKey = window.sessionStorage.getItem('trip')
  if (pubKey) {
    let str = Math.floor(10000000 + Math.random() * 90000000) + 'zwjt8081!@#DF*F&^SKD' + new Date().getTime()
    let encryptStr = new JSEncrypt()
    encryptStr.setPublicKey(pubKey)
    var zwSign = encryptStr.encrypt(str)
    config.headers['cn-sign'] = zwSign
  }
  let token = sessionStorage.getItem('token')
  if (token) {
    if (!config.headers.hasOwnProperty('Authorization')) config.headers.Authorization = token
    let ip = sessionStorage.getItem('webIp')
    let timestamp = new Date().getTime()
    let nonce = ip + '-' + timestamp

    let sign = token + nonce
    let spark = new SparkMD5()
    spark.append(sign)
    let signMd5 = spark.end()
    config.headers['zw-nonce'] = nonce
    config.headers['zw-sign'] = signMd5
  }
  return config
}, error => {
  return Promise.reject(error)
})
// 响应拦截器
axios.interceptors.response.use((response) => {
  if (response.data.resultCode === 10010 || response.data.resultCode === '1001') {
    window.sessionStorage.clear()
    window.location.href = location.href.split('?')[0]
  } else if (response.data) {
    // window.sessionStorage('token', response.data.token)
  }
  return response
}, function (error) {
  return Promise.reject(error)
})

const HTTP = {}
HTTP.get = function (url, params, parseResult = true) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      headers: sessionStorage.getItem('token') ? {
        'Zw-Type': 'ajax/json',
        'Token': sessionStorage.getItem('token')
      } : {
        'Zw-Type': 'ajax/json'
      },
      params
    }).then(response => {
      let result = response.data
      if (parseResult) {
        if (response.status === 200) {
          resolve(result.content)
        } else {
          reject(result.content)
          iView.Notice.error({ title: '提示', desc: result.message })
        }
      } else {
        resolve(result)
      }
    },
    err => {
      reject(err)
    }
    )
      .catch(error => {
        reject(error)
      })
  })
}
HTTP.post = function (url, params, parseResult = true) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params), {
      headers: {
        //  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        // //"authorization": "ISGhWNdnx8iYwnHdvnD7d1YWTq1djapnZTMj-ZoTRIw"
        // headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // "Authorization": "VeS7JZjzHPSDtjc4NhqiQ2yGMjRorpbmlc"
      }
    })
      .then(
        response => {
          let result = response.data
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content)
            } else {
              reject(result)
              iView.Notice.error({ title: '提示', desc: result.message })
            }
          } else {
            resolve(result)
          }
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}
HTTP.postPk = function (url, params, parseResult = true) {
  if (params) {
    let base = ''

    for (let key in params) {
      base += key + '=' + params[key] + '&'
    }
    base = base.substr(0, base.length - 1)
    var pubKey = window.sessionStorage.getItem('trip')
    var encryptStr = new JSEncrypt()
    encryptStr.setPublicKey(pubKey) // 设置 加密公钥
    var datas = encryptStr.encrypt(base)  // 进行加密
  } else {
    var datas = params
  }

  //        params = Base64.encode(datas);
  return new Promise((resolve, reject) => {
    axios.post(url, datas, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
      .then(
        response => {
          let result = response.data
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content)
            } else {
              reject(result)
            }
          } else {
            resolve(result)
          }
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}
HTTP.postJson = function (url, params, json, parseResult = true) {
  return new Promise((resolve, reject) => {
    axios.post(url + '?' + qs.stringify(params), json).then(response => {
      let result = response.data
      if (parseResult) {
        if (result.code === 0) {
          resolve(result.message)
        } else {
          reject(result)
        }
      } else {
        resolve(result)
      }
    }, err => {
      reject(err)
    })
      .catch((error) => {
        reject(error)
      })
  })
}
HTTP.postFormData = function (url, params, parseResult = true) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: {
        'Content-Type': 'application/json',
        'rsa': 'no',
        'token': sessionStorage.getItem('token')
      }
    })
      .then(response => {
        let result = response.data

        if (parseResult) {
          if (result.code === 0) {
            resolve(result.message)
          } else {
            reject(result)
          }
        } else {
          resolve(result)
        }
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
HTTP.json = function (url, params, parseResult = true) {
  return new Promise((resolve, reject) => {
    axios.post(url, JSON.stringify(params), {
      headers: {
        'Content-Type': 'application/json'
        // "Authorization": "VeS7JZjzHPSDtjc4NhqiQ2yGMjRorpbmlcifS7dT"
      }
    })
      .then(
        response => {
          let result = response.data
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content)
            } else {
              reject(result)
              iView.Notice.error({ title: '提示', desc: result.message })
            }
          } else {
            resolve(result)
          }
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}
HTTP.jsonPk = function (url, params, parseResult = true) {
  if (params) {
    let param = JSON.stringify(params)
    var pubKey = window.sessionStorage.getItem('trip')
    var encryptStr = new JSEncrypt()
    encryptStr.setPublicKey(pubKey) // 设置 加密公钥
    var data = encryptStr.encrypt(param)  // 进行加密
  } else {
    var data = params
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
        // "Authorization": "VeS7JZjzHPSDtjc4NhqiQ2yGMjRorpbmlcifS7dT"
      }
    }).then(
      response => {
        let result = response.data
        if (parseResult) {
          if (response.status === 200) {
            resolve(result.content)
          } else {
            reject(result)
          }
        } else {
          resolve(result)
        }
      },
      err => {
        reject(err)
      }
    )
      .catch(error => {
        reject(error)
      })
  })
}
HTTP.jsonToken = function (url, params, parseResult = true) {
  if (params) {
    let param = JSON.stringify(params)

    var pubKey = window.sessionStorage.getItem('trip')
    var encryptStr = new JSEncrypt()
    encryptStr.setPublicKey(pubKey) // 设置 加密公钥
    var data = encryptStr.encrypt(param)  // 进行加密
  } else {
    var data = params
  }
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url,
      baseURL: url,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'token': window.sessionStorage.getItem('token')
      },
      data: data
    })
      .then(
        response => {
          let result = response.data
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content)
            } else {
              reject(result)
            }
          } else {
            resolve(result)
          }
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}
export default HTTP
